import { apiAdminClient, apiUserClient } from "../_lib/apiClient";

const getTransactions = async ({ bookingId }) => {
  const response = await apiAdminClient.get(`/transaction/booking/${bookingId}`);
  return response;
};

const getTransactionDetails = async ({ transactionId }) => {
  const response = await apiAdminClient.get(`/transaction/${transactionId}/detail`);
  return response;
};

const getPayouts = async ({ bookingId }) => {
  const response = await apiUserClient.get(`/transaction/payout/${bookingId}`);
  return response;
};

const getPayoutDetails = async ({ payoutId }) => {
  const response = await apiUserClient.get(`/transaction/payout/${payoutId}/detail`);
  return response;
};

const comissionList = async (page, searchValue) => {
  const response = await apiAdminClient.get(
    `/crewmate/commissions?page=${page}&reservationId=${searchValue}`
  );
  return response;
};

const handlePayoutRequestForAdmin = async (operationKey) => {
  const response = await apiAdminClient.post(`/crewmate/handle-payout-request-admin`, {}, {
    headers: {
      "Idempotency-Key": operationKey,
    },
  });
  return response;
};

const getAdminPayoutOperation = async (operationId) => {
  return apiAdminClient.get(`/crewmate/payout-operations/${operationId}`);
};

const getActiveAdminPayoutOperation = async () => {
  return apiAdminClient.get(`/crewmate/payout-operations/active`);
};

const createPayoutOperationKey = () => {
  if (globalThis.crypto && typeof globalThis.crypto.randomUUID === "function") {
    return globalThis.crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);
  return `payout:${Array.from(bytes, (value) =>
    value.toString(16).padStart(2, "0")
  ).join("")}`;
};

const getGraphData = async (data) => {
  return await apiUserClient.post("/custom/admin-graph-data", data);
};

const getAggregatedList = async (page, searchValue) => {
  const res = await apiAdminClient.get(`/crewmate/payout-list?page=${page}&hostId=${searchValue}`)
  return res
}

const getHostBalanceList = async (page, searchValue) => {
  const res = await apiAdminClient.get(`/crewmate/host-balance-list?page=${page}&hostId=${searchValue}`)
  return res
}

const getHostBalances = async ({ page = 1, limit = 10, hostId = "", currency = "usd" } = {}) => {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));
  if (hostId !== undefined && hostId !== null && String(hostId).trim() !== "") {
    params.set("hostId", String(hostId).trim());
  }
  params.set("currency", String(currency || "usd").toLowerCase());

  return apiAdminClient.get(`/finance/host-balances?${params.toString()}`);
}

const getFinanceSummary = async ({
  period = "last7Days",
  page = 1,
  limit = 10,
  reservationId = "",
  currency = "usd",
  fromDate,
  toDate,
} = {}) => {
  const params = new URLSearchParams();
  params.set("period", String(period));
  params.set("currency", String(currency || "usd").toLowerCase());
  params.set("page", String(page));
  params.set("limit", String(limit));
  if (String(reservationId || "").trim()) {
    params.set("reservationId", String(reservationId).trim());
  }
  if (period === "custom") {
    params.set("fromDate", String(fromDate || ""));
    params.set("toDate", String(toDate || ""));
  }

  return apiAdminClient.get(`/finance/summary?${params.toString()}`, null, { config: { timeout: 25000 } });
};

const getCommissionActivity = async ({ page = 1, limit = 10, reservationId = "", fromDate, toDate, asOf } = {}) => {
  const params = new URLSearchParams({ page: String(page), limit: String(limit), currency: "usd" });
  if (String(reservationId || "").trim()) params.set("reservationId", String(reservationId).trim());
  if (fromDate || toDate) {
    params.set("fromDate", fromDate || "");
    params.set("toDate", toDate || "");
  }
  if (asOf) params.set("asOf", asOf);
  return apiAdminClient.get(`/finance/commission-activity?${params.toString()}`, null, { config: { timeout: 25000 } });
};

export const payoutService = {
  getCommissionActivity,
  getTransactions,
  getTransactionDetails,
  getPayouts,
  getPayoutDetails,
  comissionList,
  handlePayoutRequestForAdmin,
  getAdminPayoutOperation,
  getActiveAdminPayoutOperation,
  createPayoutOperationKey,
  getGraphData,
  getAggregatedList,
  getHostBalanceList,
  getHostBalances,
  getFinanceSummary,
};
